module.exports = __webpack_public_path__ + "static/media/squarePharmaceuticals.64d50436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/sponsors/squarePharmaceuticals.jpg
// module id = 1149
// module chunks = 0